module.exports = __webpack_public_path__ + "img/promo-bg.5877d52.jpg";